import React from 'react';
import { Col, Row } from 'antd';
import TransactionsPerformance from './components/TransactionsPerformance';
import TransactionCreativeDetails from './components/transactionCreatives/TransactionCreativesDetails';
import TransactionPublisherDetails from './components/transactionPublishers/TransactionPublisherDetails';
import TransactionDetails from './components/transactions/TransactionDetails';
import TransactionCampaignTabs from './components/TransactionCampaignTabs';
import { canShowTransactionMetrics } from './transactionMetricsVisibility';

// =============================================================================
// TransactionsTab (V2) — modern Transactions tab composer.
//
// Stage 1 of the v2 design-system migration: the KPI bar and By Date /
// Day of Week chart are unified into a single Performance card (matches
// Summary / Display / legacy-Transactions patterns). Attribution window +
// method stay on the Transactions table below — same rationale as V1 since
// they conceptually belong with the transaction list that shows attributed
// events. Creatives / Publishers entity cards remain untouched this stage.
// =============================================================================

const TransactionsTab = ({
  byDate,
  byDayOfWeek,
  defaultSummaryDates,
  creatives,
  publishers,
  transactions,
  transactionsPagination,
  getImpressions,
  detailBarSummary,
  changeDatePicker,
  changeAttributionWindow,
  attributionWindow,
  attributionMethod,
  changeAttributionMethod,
  campaignOrder,
  // Individual loading states
  byDateLoading,
  creativesLoading,
  publishersLoading,
  transactionsLoading,
  detailsLoading,
  creativesByDateLoading,
  publishersByDateLoading,
  // Campaign tab props
  campaignIndex,
  setCampaignIndex,
  transactionsByCampaign,
  showCampaignTabs,
  campaignByDateLoading,
}) => {
  // Impressions/Transactions columns on the Creatives & Publishers tables are
  // gated on the assigned advertiser's PartnerLevel.
  const showMetrics = canShowTransactionMetrics(campaignOrder?.advertiser?.level);

  return (
    <>
      {showCampaignTabs && (
        <TransactionCampaignTabs
          campaigns={transactionsByCampaign}
          campaignIndex={campaignIndex}
          setCampaignIndex={setCampaignIndex}
        />
      )}

      <TransactionsPerformance
        data={detailBarSummary}
        byDate={byDate}
        byDayOfWeek={byDayOfWeek}
        defaultSummaryDates={defaultSummaryDates}
        changeDatePicker={changeDatePicker}
        loading={detailsLoading || byDateLoading}
      />

      <Row gutter={[35, 35]} style={{ marginTop: '1%' }}>
        <Col span={24}>
          <TransactionCreativeDetails
            creatives={creatives}
            loading={creativesLoading}
            byDateLoading={creativesByDateLoading}
            showMetrics={showMetrics}
          />
        </Col>
        <Col span={24}>
          <TransactionPublisherDetails
            publishers={publishers}
            loading={publishersLoading}
            byDateLoading={publishersByDateLoading}
            showMetrics={showMetrics}
          />
        </Col>
        <Col span={24}>
          <TransactionDetails
            transactions={transactions}
            transactionsPagination={transactionsPagination}
            getImpressions={getImpressions}
            loading={transactionsLoading}
            changeAttributionWindow={changeAttributionWindow}
            attributionWindow={attributionWindow}
            changeAttributionMethod={changeAttributionMethod}
            attributionMethod={attributionMethod}
          />
        </Col>
      </Row>
    </>
  );
};

export default TransactionsTab;
